import { Card } from "@/components/ui/card";
import ConsultationTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";

const Consultation = () => {
  useDocumentTitle("Consultations");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <ConsultationTableView />
      </Card>
    </div>
  );
};

export default Consultation;

